export function formatRecipientAgency(value: unknown): string {
  const raw = String(value ?? '').trim();
  if (!raw) {
    return '';
  }
  if (raw.includes('-')) {
    return raw;
  }
  const digits = raw.replace(/\D/g, '');
  if (!digits) {
    return raw;
  }
  if (digits.length <= 4) {
    return digits.padStart(4, '0');
  }
  const body = digits.slice(0, -1).padStart(4, '0');
  return `${body}-${digits.slice(-1)}`;
}

export function formatRecipientAccount(value: unknown): string {
  const raw = String(value ?? '').trim();
  if (!raw) {
    return '';
  }
  if (raw.includes('-')) {
    return raw;
  }
  const digits = raw.replace(/\D/g, '');
  if (!digits) {
    return raw;
  }
  if (digits.length <= 1) {
    return digits;
  }
  return `${digits.slice(0, -1)}-${digits.slice(-1)}`;
}
